import { IconX } from '@tabler/icons-react';

import styled from 'styled-components';

import { BRAND_COLORS } from 'brand-guidelines/colors';

export const StyledCloseButton = styled.button.attrs({
  type: 'button',
})`
  position: absolute;
  top: 0;
  right: 0;
  /* Use padding instead of top and right to create a larger touch target */
  padding: 10px 10px 0 0;

  background: 0;
  border: 0;
  cursor: pointer;
`;

export const StyledCloseIcon = styled(IconX).attrs({
  size: 24,
})`
  color: ${BRAND_COLORS.darkGray};
`;
